export enum PropertyType {
	BOOLEAN,
	DATE,
	EMAIL,
	IMAGE,
	NUMBER,
	STRING,
	ENUM,
	COLOR
}
